var path = 'app/reporting/site_specific/listAnalytics.html';
var html = "<div ng-include=\"'app/reporting/lists/reportsList.html'\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;